import type { CricketTournamentPage } from "../types"

const baseCricketTournaments: CricketTournamentPage[] = [
  {
    slug: "cricket-world-cup",
    title: "ICC Cricket World Cup",
    type: "international",
    definition:
      "ICC Cricket World Cup ek global ODI tournament hai jahan top international teams group stage, knockout stage aur final ke zariye world champion decide karti hain.",
    summary:
      "Cricket World Cup mens ODI cricket ka sab se iconic global tournament hai aur world champions ka sab se famous title isi se attach hota hai.",
    hero: {
      firstPlayed: "1975",
      format: "ODI",
      teams: "Usually 10",
    },
    history: [
      "1975 mein England mein shuru hua aur jaldi hi ODI cricket ka sab se prestigious tournament ban gaya.",
      "West Indies ke early dominance ke baad India, Australia, Pakistan, Sri Lanka aur England sab ne is stage par apni historical identity build ki.",
    ],
    formatNotes: [
      "Modern edition mein group stage ke baad knockout stage aur final hota hai.",
      "50-over format ki wajah se batting depth, middle overs control aur pressure finishing sab important hotay hain.",
    ],
    winners: [
      { year: "1975", winner: "West Indies", runnerUp: "Australia" },
      { year: "1979", winner: "West Indies", runnerUp: "England" },
      { year: "1983", winner: "India", runnerUp: "West Indies" },
      { year: "1987", winner: "Australia", runnerUp: "England" },
      { year: "1992", winner: "Pakistan", runnerUp: "England" },
      { year: "1996", winner: "Sri Lanka", runnerUp: "Australia" },
      { year: "1999", winner: "Australia", runnerUp: "Pakistan" },
      { year: "2003", winner: "Australia", runnerUp: "India" },
      { year: "2007", winner: "Australia", runnerUp: "Sri Lanka" },
      { year: "2011", winner: "India", runnerUp: "Sri Lanka" },
      { year: "2015", winner: "Australia", runnerUp: "New Zealand" },
      { year: "2019", winner: "England", runnerUp: "New Zealand" },
      { year: "2023", winner: "Australia", runnerUp: "India" },
    ],
    records: [
      {
        label: "Most titles",
        value: "Australia - 6",
      },
      {
        label: "Most runs",
        value: "Sachin Tendulkar",
        note: "World Cup history ke sab se zyada runs",
      },
      {
        label: "Most wickets",
        value: "Glenn McGrath",
        note: "ODI World Cup wicket chart ka historic leader",
      },
    ],
    topPerformances: [
      {
        player: "Kapil Dev",
        performance: "175* vs Zimbabwe",
        note: "1983 World Cup ki sab se iconic rescue innings mein se aik.",
      },
      {
        player: "Ben Stokes",
        performance: "2019 World Cup Final heroics",
        note: "Final aur super over pressure ne is performance ko immortal bana diya.",
      },
      {
        player: "Adam Gilchrist",
        performance: "149 in 2007 Final",
        note: "World Cup final batting destruction ka legendary example.",
      },
    ],
    timeline: [
      { year: "1975", event: "First Cricket World Cup England mein shuru hua." },
      { year: "1992", event: "Colored kits aur white ball ne tournament ki presentation ko modern banaya." },
      { year: "2007", event: "Super 8 structure ne tournament format ko zyada layered banaya." },
      { year: "2019", event: "10-team round robin model ne every-match pressure ko bohat high kar diya." },
    ],
    famousMatches: ["wc-1992-final", "wc-2011-final", "wc-2019-final", "wc-2023-final"],
    relatedPlayers: ["sachin-tendulkar", "ms-dhoni", "wasim-akram", "rohit-sharma"],
    relatedRecords: ["most-runs", "most-wickets"],
  },
  {
    slug: "t20-world-cup",
    title: "ICC Men's T20 World Cup",
    type: "international",
    summary:
      "T20 World Cup mens international T20 cricket ka sab se important global event hai jahan short-format pressure aur explosive cricket dono peak par hotay hain.",
    hero: {
      firstPlayed: "2007",
      format: "T20I",
      teams: "20 era tak expanded",
    },
    history: [
      "2007 World Twenty20 ne short-format ko global legitimacy di aur India vs Pakistan final ne tournament ko instantly iconic bana diya.",
      "Is event ne T20 specialists, death bowling aur power-hitting ko world stage par permanent importance di.",
    ],
    formatNotes: [
      "Tournament mein group phase aur phir knockouts hotay hain.",
      "Short format hone ki wajah se net run rate aur matchups ka influence bohat zyada hota hai.",
    ],
    winners: [
      { year: "2007", winner: "India", runnerUp: "Pakistan" },
      { year: "2009", winner: "Pakistan", runnerUp: "Sri Lanka" },
      { year: "2010", winner: "England", runnerUp: "Australia" },
      { year: "2012", winner: "West Indies", runnerUp: "Sri Lanka" },
      { year: "2014", winner: "Sri Lanka", runnerUp: "India" },
      { year: "2016", winner: "West Indies", runnerUp: "England" },
      { year: "2021", winner: "Australia", runnerUp: "New Zealand" },
      { year: "2022", winner: "England", runnerUp: "Pakistan" },
      { year: "2024", winner: "India", runnerUp: "South Africa" },
      { year: "2026", winner: "India", runnerUp: "New Zealand" },
    ],
    records: [
      {
        label: "Most titles",
        value: "India - 3",
      },
      {
        label: "Historic launch final",
        value: "India vs Pakistan 2007",
        note: "Tournament ki identity define karne wala final",
      },
      {
        label: "Popular search angle",
        value: "Winners list",
        note: "T20 World Cup history queries ke liye highest-intent section",
      },
    ],
    famousMatches: ["wt20-2007-final", "t20wc-2021-ind-vs-pak", "t20wc-2022-ind-vs-pak", "india-vs-newzealand-2026-t20-world-cup-final"],
    relatedPlayers: ["virat-kohli", "babar-azam", "ms-dhoni", "mohammad-rizwan"],
    relatedRecords: ["most-runs", "most-sixes"],
  },
  {
    slug: "champions-trophy",
    title: "ICC Champions Trophy",
    type: "international",
    summary:
      "Champions Trophy short ICC ODI event tha jise aksar mini World Cup bhi kaha gaya, kyun ke is mein elite teams aur fast knockout pressure hota tha.",
    hero: {
      firstPlayed: "1998",
      format: "ODI",
      teams: "Elite international sides",
    },
    history: [
      "Tournament shuru mein ICC KnockOut ke naam se aaya aur baad mein Champions Trophy bana.",
      "Chhota schedule aur high-stakes matches ki wajah se iski identity World Cup se alag rahi.",
    ],
    formatNotes: [
      "Short ODI tournament hone ki wajah se early defeat ka damage bohat bada hota tha.",
      "Semi-final aur final pressure ne isay big-match teams ke liye strong test banaya.",
    ],
    winners: [
      { year: "1998", winner: "South Africa", runnerUp: "West Indies" },
      { year: "2000", winner: "New Zealand", runnerUp: "India" },
      { year: "2002", winner: "India and Sri Lanka", runnerUp: "Shared Final" },
      { year: "2004", winner: "West Indies", runnerUp: "England" },
      { year: "2006", winner: "Australia", runnerUp: "West Indies" },
      { year: "2009", winner: "Australia", runnerUp: "New Zealand" },
      { year: "2013", winner: "India", runnerUp: "England" },
      { year: "2017", winner: "Pakistan", runnerUp: "India" },
      { year: "2025", winner: "India", runnerUp: "New Zealand" },
    ],
    records: [
      {
        label: "Most titles",
        value: "India - 3",
      },
      {
        label: "Most remembered final",
        value: "Pakistan vs India 2017",
        note: "Modern era ka sab se searched Champions Trophy page",
      },
      {
        label: "Tournament identity",
        value: "Mini World Cup",
        note: "Short schedule, high pressure",
      },
    ],
    famousMatches: ["ct-2017-final"],
    relatedPlayers: ["babar-azam", "virat-kohli", "shaheen-shah-afridi", "rohit-sharma"],
    relatedRecords: ["highest-team-score", "most-runs"],
  },
  {
    slug: "world-test-championship",
    title: "ICC World Test Championship",
    type: "international",
    summary:
      "World Test Championship Test cricket ko league-plus-final structure deta hai aur modern era mein red-ball supremacy ka official title provide karta hai.",
    hero: {
      firstPlayed: "2019",
      format: "Test",
      teams: "9 major teams cycle",
    },
    history: [
      "WTC ka maqsad Test cricket ko clear championship narrative dena tha jahan multiple bilateral series aik larger table ka hissa ban jayein.",
      "Cycle-based structure ne points table, percentage system aur final ke concept ko Test audiences ke liye central bana diya.",
    ],
    formatNotes: [
      "Teams cycle ke dauran selected Test series khelti hain aur points percentage decide karta hai kaun final mein jaye ga.",
      "Final aik standalone Test hota hai jo title winner decide karta hai.",
    ],
    winners: [
      { year: "2019-21", winner: "New Zealand", runnerUp: "India" },
      { year: "2021-23", winner: "Australia", runnerUp: "India" },
      { year: "2023-25", winner: "South Africa", runnerUp: "Australia" },
    ],
    records: [
      {
        label: "Current completed titles",
        value: "New Zealand, Australia, South Africa",
      },
      {
        label: "Format appeal",
        value: "League plus final",
        note: "Test cricket ko season-like narrative deta hai",
      },
      {
        label: "Key strength",
        value: "Context",
        note: "Har series ko bigger championship story se jorta hai",
      },
    ],
    famousMatches: ["south-africa-vs-australia-2025-wtc-final"],
    relatedPlayers: ["joe-root", "kane-williamson", "steve-smith", "pat-cummins"],
    relatedRecords: ["most-runs", "best-bowling-average"],
  },
  {
    slug: "asia-cup",
    title: "Asia Cup",
    type: "regional",
    summary:
      "Asia Cup Asian cricket ka sab se important regional tournament hai aur India, Pakistan, Sri Lanka, Bangladesh jesi teams ke darmiyan historical rivalry ko structured stage deta hai.",
    hero: {
      firstPlayed: "1984",
      format: "ODI or T20",
      teams: "Asian sides",
    },
    history: [
      "Asia Cup ka core appeal regional rivalry aur subcontinent fan intensity hai.",
      "Tournament ne alag eras mein ODI aur T20 dono formats adopt kiye, lekin India-Pakistan aur India-Sri Lanka narratives hamesha central rahe.",
    ],
    formatNotes: [
      "Edition ke mutabiq ODI ya T20 format use hota hai.",
      "Super Four jese structures ne tournament ko simple knockout se zyada layered banaya.",
    ],
    winners: [
      { year: "1984", winner: "India", runnerUp: "Sri Lanka" },
      { year: "1986", winner: "Sri Lanka", runnerUp: "Pakistan" },
      { year: "1988", winner: "India", runnerUp: "Sri Lanka" },
      { year: "1990-91", winner: "India", runnerUp: "Sri Lanka" },
      { year: "1995", winner: "India", runnerUp: "Sri Lanka" },
      { year: "1997", winner: "Sri Lanka", runnerUp: "India" },
      { year: "2000", winner: "Pakistan", runnerUp: "Sri Lanka" },
      { year: "2004", winner: "Sri Lanka", runnerUp: "India" },
      { year: "2008", winner: "Sri Lanka", runnerUp: "India" },
      { year: "2010", winner: "India", runnerUp: "Sri Lanka" },
      { year: "2012", winner: "Pakistan", runnerUp: "Bangladesh" },
      { year: "2014", winner: "Sri Lanka", runnerUp: "Pakistan" },
      { year: "2016", winner: "India", runnerUp: "Bangladesh" },
      { year: "2018", winner: "India", runnerUp: "Bangladesh" },
      { year: "2022", winner: "Sri Lanka", runnerUp: "Pakistan" },
      { year: "2023", winner: "India", runnerUp: "Sri Lanka" },
    ],
    records: [
      {
        label: "Most titles",
        value: "India",
      },
      {
        label: "Rivalry appeal",
        value: "India vs Pakistan",
        note: "Tournament search interest ka major driver",
      },
      {
        label: "Format flexibility",
        value: "ODI and T20",
        note: "Upcoming global event ke mutabiq format shift hota raha",
      },
    ],
    famousMatches: ["ct-2017-final", "t20wc-2022-ind-vs-pak"],
    relatedPlayers: ["sachin-tendulkar", "virat-kohli", "babar-azam", "muttiah-muralitharan"],
    relatedRecords: ["most-runs", "most-wickets"],
  },
  {
    slug: "ipl",
    title: "Indian Premier League",
    type: "franchise",
    summary:
      "IPL duniya ki sab se famous T20 franchise league hai jahan star players, high-value squads aur short-format innovation sab aik jagah milte hain.",
    hero: {
      firstPlayed: "2008",
      format: "T20",
      teams: "Franchise teams",
    },
    history: [
      "IPL ne franchise cricket ko global mainstream banaya aur T20 strategy, player branding aur league economics ko redefine kiya.",
      "Mumbai Indians aur Chennai Super Kings jesi teams ne league ko dynasty-style narratives diye.",
    ],
    formatNotes: [
      "League stage ke baad playoffs aur final hota hai.",
      "Squad depth, matchups, death bowling aur finishing batters IPL success ke core ingredients hain.",
    ],
    winners: [
      { year: "2008", winner: "Rajasthan Royals", runnerUp: "Chennai Super Kings" },
      { year: "2009", winner: "Deccan Chargers", runnerUp: "Royal Challengers Bangalore" },
      { year: "2010", winner: "Chennai Super Kings", runnerUp: "Mumbai Indians" },
      { year: "2011", winner: "Chennai Super Kings", runnerUp: "Royal Challengers Bangalore" },
      { year: "2012", winner: "Kolkata Knight Riders", runnerUp: "Chennai Super Kings" },
      { year: "2013", winner: "Mumbai Indians", runnerUp: "Chennai Super Kings" },
      { year: "2014", winner: "Kolkata Knight Riders", runnerUp: "Kings XI Punjab" },
      { year: "2015", winner: "Mumbai Indians", runnerUp: "Chennai Super Kings" },
      { year: "2016", winner: "Sunrisers Hyderabad", runnerUp: "Royal Challengers Bangalore" },
      { year: "2017", winner: "Mumbai Indians", runnerUp: "Rising Pune Supergiant" },
      { year: "2018", winner: "Chennai Super Kings", runnerUp: "Sunrisers Hyderabad" },
      { year: "2019", winner: "Mumbai Indians", runnerUp: "Chennai Super Kings" },
      { year: "2020", winner: "Mumbai Indians", runnerUp: "Delhi Capitals" },
      { year: "2021", winner: "Chennai Super Kings", runnerUp: "Kolkata Knight Riders" },
      { year: "2022", winner: "Gujarat Titans", runnerUp: "Rajasthan Royals" },
      { year: "2023", winner: "Chennai Super Kings", runnerUp: "Gujarat Titans" },
      { year: "2024", winner: "Kolkata Knight Riders", runnerUp: "Sunrisers Hyderabad" },
      { year: "2025", winner: "Royal Challengers Bengaluru", runnerUp: "Punjab Kings" },
    ],
    records: [
      {
        label: "Most titles",
        value: "Mumbai Indians and Chennai Super Kings",
      },
      {
        label: "Search-heavy topic",
        value: "IPL winners list",
        note: "Beginners aur casual fans dono ke liye top query",
      },
      {
        label: "Format identity",
        value: "High-intensity T20 league",
      },
    ],
    famousMatches: ["ipl-2016-final", "ipl-2019-final", "ipl-2023-final"],
    relatedPlayers: ["ms-dhoni", "rohit-sharma", "virat-kohli", "jasprit-bumrah"],
    relatedRecords: ["most-sixes", "highest-team-score"],
  },
  {
    slug: "psl",
    title: "Pakistan Super League",
    type: "franchise",
    summary:
      "PSL Pakistan ki flagship T20 franchise league hai jo fast bowling depth, local talent emergence aur short-format rivalries ki wajah se strong identity rakhti hai.",
    hero: {
      firstPlayed: "2016",
      format: "T20",
      teams: "Franchise teams",
    },
    history: [
      "PSL ne Pakistan cricket ko structured franchise platform diya aur naye local players ko national conversation mein lane mein bohat bada role ada kiya.",
      "League ki identity pace bowling, close finishes aur Pakistan talent pipeline ke sath strongly linked rahi hai.",
    ],
    formatNotes: [
      "League stage ke baad playoffs aur final hota hai.",
      "PSL squads mein local fast bowlers aur all-round balance bohat important role play karte hain.",
    ],
    winners: [
      { year: "2016", winner: "Islamabad United", runnerUp: "Quetta Gladiators" },
      { year: "2017", winner: "Peshawar Zalmi", runnerUp: "Quetta Gladiators" },
      { year: "2018", winner: "Islamabad United", runnerUp: "Peshawar Zalmi" },
      { year: "2019", winner: "Quetta Gladiators", runnerUp: "Peshawar Zalmi" },
      { year: "2020", winner: "Karachi Kings", runnerUp: "Lahore Qalandars" },
      { year: "2021", winner: "Multan Sultans", runnerUp: "Peshawar Zalmi" },
      { year: "2022", winner: "Lahore Qalandars", runnerUp: "Multan Sultans" },
      { year: "2023", winner: "Lahore Qalandars", runnerUp: "Multan Sultans" },
      { year: "2024", winner: "Islamabad United", runnerUp: "Multan Sultans" },
      { year: "2025", winner: "Lahore Qalandars", runnerUp: "Quetta Gladiators" },
    ],
    records: [
      {
        label: "Most titles",
        value: "Islamabad United and Lahore Qalandars",
      },
      {
        label: "League identity",
        value: "Pakistan talent platform",
        note: "Fast bowlers aur emerging players ke liye major stage",
      },
      {
        label: "Search-heavy topic",
        value: "PSL winners list",
      },
    ],
    famousMatches: ["ct-2017-final"],
    relatedPlayers: ["babar-azam", "shaheen-shah-afridi", "mohammad-rizwan", "wasim-akram"],
    relatedRecords: ["most-sixes", "highest-team-score"],
  },
  {
    slug: "indian-premier-league",
    title: "Indian Premier League",
    type: "franchise",
    summary:
      "Indian Premier League duniya ki sab se famous T20 franchise league hai jahan stars, money, tactics aur huge audiences sab aik jagah milte hain.",
    hero: {
      firstPlayed: "2008",
      format: "T20",
      teams: "Franchise teams",
    },
    history: [
      "IPL ne franchise cricket ko global mainstream banaya aur T20 strategy, branding aur league economics ko redefine kiya.",
      "Mumbai Indians aur Chennai Super Kings jesi teams ne league ko dynasty-style narratives diye.",
    ],
    formatNotes: [
      "League stage ke baad playoffs aur final hota hai.",
      "Finishing batters, death bowlers aur matchup planning IPL success ke major pillars hain.",
    ],
    winners: [
      { year: "2008", winner: "Rajasthan Royals", runnerUp: "Chennai Super Kings" },
      { year: "2013", winner: "Mumbai Indians", runnerUp: "Chennai Super Kings" },
      { year: "2018", winner: "Chennai Super Kings", runnerUp: "Sunrisers Hyderabad" },
      { year: "2023", winner: "Chennai Super Kings", runnerUp: "Gujarat Titans" },
      { year: "2024", winner: "Kolkata Knight Riders", runnerUp: "Sunrisers Hyderabad" },
      { year: "2025", winner: "Royal Challengers Bengaluru", runnerUp: "Punjab Kings" },
    ],
    records: [
      { label: "Most titles", value: "Mumbai Indians and Chennai Super Kings" },
      { label: "Most searched topic", value: "IPL winners list" },
      { label: "Format identity", value: "High-intensity T20 franchise league" },
    ],
    famousMatches: ["ipl-2016-final", "ipl-2019-final", "ipl-2023-final"],
    relatedPlayers: ["ms-dhoni", "rohit-sharma", "virat-kohli", "jasprit-bumrah"],
    relatedRecords: ["most-sixes", "highest-team-score"],
  },
  {
    slug: "pakistan-super-league",
    title: "Pakistan Super League",
    type: "franchise",
    summary:
      "Pakistan Super League Pakistan ki flagship T20 franchise league hai jo pace bowling, local talent aur close finishes ki wajah se strong identity rakhti hai.",
    hero: {
      firstPlayed: "2016",
      format: "T20",
      teams: "Franchise teams",
    },
    history: [
      "PSL ne Pakistan cricket ko structured franchise platform diya aur naye local players ko national conversation mein lane mein bohat bada role ada kiya.",
      "League ki identity pace bowling, young talent aur close high-pressure matches ke sath strongly linked rahi.",
    ],
    formatNotes: [
      "League stage ke baad playoffs aur final hota hai.",
      "Local fast bowlers, powerplay wickets aur middle-order finishing PSL narratives ke major parts hote hain.",
    ],
    winners: [
      { year: "2016", winner: "Islamabad United", runnerUp: "Quetta Gladiators" },
      { year: "2017", winner: "Peshawar Zalmi", runnerUp: "Quetta Gladiators" },
      { year: "2022", winner: "Lahore Qalandars", runnerUp: "Multan Sultans" },
      { year: "2023", winner: "Lahore Qalandars", runnerUp: "Multan Sultans" },
      { year: "2024", winner: "Islamabad United", runnerUp: "Multan Sultans" },
      { year: "2025", winner: "Lahore Qalandars", runnerUp: "Quetta Gladiators" },
    ],
    records: [
      { label: "Most titles", value: "Islamabad United and Lahore Qalandars" },
      { label: "League identity", value: "Pakistan talent platform" },
      { label: "Popular query", value: "PSL winners list" },
    ],
    famousMatches: ["ct-2017-final"],
    relatedPlayers: ["babar-azam", "shaheen-shah-afridi", "mohammad-rizwan", "haris-rauf"],
    relatedRecords: ["most-sixes", "highest-team-score"],
  },
  {
    slug: "big-bash-league",
    title: "Big Bash League",
    type: "franchise",
    summary:
      "Big Bash League Australia ki flagship T20 competition hai jo family-friendly presentation aur explosive white-ball cricket ki wajah se globally popular hui.",
    hero: {
      firstPlayed: "2011",
      format: "T20",
      teams: "Australian franchises",
    },
    history: [
      "BBL ne Australian domestic T20 ko strong broadcast identity di aur summer cricket entertainment ka major brand ban gaya.",
      "League ki image colorful branding, six-hitting aur fast-paced matches se strongly linked rahi.",
    ],
    formatNotes: [
      "League stage ke baad finals structure hota hai.",
      "Short boundaries, aggressive batting aur matchup bowling BBL discussion ke common parts hain.",
    ],
    winners: [
      { year: "2011-12", winner: "Sydney Sixers", runnerUp: "Perth Scorchers" },
      { year: "2013-14", winner: "Perth Scorchers", runnerUp: "Hobart Hurricanes" },
      { year: "2021-22", winner: "Perth Scorchers", runnerUp: "Sydney Sixers" },
      { year: "2022-23", winner: "Perth Scorchers", runnerUp: "Brisbane Heat" },
      { year: "2023-24", winner: "Brisbane Heat", runnerUp: "Sydney Sixers" },
    ],
    records: [
      { label: "Most titles", value: "Perth Scorchers" },
      { label: "League vibe", value: "Australian summer T20 festival" },
      { label: "Popular query", value: "BBL winners list" },
    ],
    relatedPlayers: ["david-warner", "steve-smith", "brett-lee", "mitchell-starc"],
    relatedRecords: ["most-sixes-t20", "highest-score-t20"],
  },
  {
    slug: "caribbean-premier-league",
    title: "Caribbean Premier League",
    type: "franchise",
    summary:
      "Caribbean Premier League ya CPL Caribbean T20 league hai jo flair, six-hitting aur island cricket culture ki wajah se unique identity rakhti hai.",
    hero: {
      firstPlayed: "2013",
      format: "T20",
      teams: "Caribbean franchises",
    },
    history: [
      "CPL ne Caribbean cricket ko franchise level par strong entertainment identity di.",
      "League ki image power-hitters, celebratory culture aur high-scoring T20 matches se linked rahi.",
    ],
    formatNotes: [
      "League stage aur knockout style finish hoti hai.",
      "Power-hitting aur mystery spin CPL talking points ke common parts hain.",
    ],
    winners: [
      { year: "2013", winner: "Jamaica Tallawahs", runnerUp: "Guyana Amazon Warriors" },
      { year: "2017", winner: "Trinbago Knight Riders", runnerUp: "St Kitts and Nevis Patriots" },
      { year: "2020", winner: "Trinbago Knight Riders", runnerUp: "St Lucia Zouks" },
      { year: "2023", winner: "Guyana Amazon Warriors", runnerUp: "Trinbago Knight Riders" },
    ],
    records: [
      { label: "Most titles", value: "Trinbago Knight Riders" },
      { label: "League identity", value: "Caribbean flair and power-hitting" },
      { label: "Popular query", value: "CPL winners list" },
    ],
    relatedPlayers: ["chris-gayle", "andre-russell", "sunil-narine", "kieron-pollard"],
    relatedRecords: ["most-sixes-t20", "highest-score-t20"],
  },
  {
    slug: "the-hundred",
    title: "The Hundred",
    type: "franchise",
    summary:
      "The Hundred England ka 100-ball competition hai jo traditional T20 se slightly different structure aur presentation style rakhta hai.",
    hero: {
      firstPlayed: "2021",
      format: "100-ball",
      teams: "City-based teams",
    },
    history: [
      "The Hundred ko naye audience segments ko attract karne aur short-format cricket ko fresh packaging dene ke liye launch kiya gaya.",
      "100-ball structure aur modern branding ne is competition ko baqi leagues se alag identity di.",
    ],
    formatNotes: [
      "Matches 100 balls per innings par based hoti hain.",
      "Bowling blocks aur innings framing T20 se slightly different hoti hai.",
    ],
    winners: [
      { year: "2021", winner: "Southern Brave", runnerUp: "Birmingham Phoenix" },
      { year: "2022", winner: "Trent Rockets", runnerUp: "Manchester Originals" },
      { year: "2023", winner: "Oval Invincibles", runnerUp: "Manchester Originals" },
      { year: "2024", winner: "Oval Invincibles", runnerUp: "Southern Brave" },
    ],
    records: [
      { label: "Format identity", value: "100-ball cricket" },
      { label: "Popular query", value: "What is The Hundred format?" },
      { label: "League appeal", value: "Short, modern and city-based" },
    ],
    relatedPlayers: ["jos-buttler", "ben-stokes", "joe-root", "suryakumar-yadav"],
    relatedRecords: ["highest-score-t20", "most-sixes-t20"],
  },
  {
    slug: "ashes-series",
    title: "Ashes Series",
    type: "international",
    summary:
      "Ashes Series England aur Australia ke darmiyan Test cricket ki sab se famous rivalry hai jo history, prestige aur long-format intensity ki wajah se special status rakhti hai.",
    hero: {
      firstPlayed: "1882",
      format: "Test",
      teams: "England vs Australia",
    },
    history: [
      "Ashes cricket ki sab se old aur famous bilateral rivalries mein se aik hai.",
      "Series ne generation after generation iconic players, classic Tests aur cultural cricket moments produce kiye hain.",
    ],
    formatNotes: [
      "Ashes sirf Test cricket mein kheli jati hai.",
      "Series length edition ke mutabiq vary kar sakti hai lekin prestige hamesha bohat high rehta hai.",
    ],
    winners: [
      { year: "2005", winner: "England", runnerUp: "Australia" },
      { year: "2013-14", winner: "Australia", runnerUp: "England" },
      { year: "2019", winner: "Australia retained", runnerUp: "England" },
      { year: "2023", winner: "Australia retained", runnerUp: "England" },
    ],
    records: [
      { label: "Format", value: "Test cricket only" },
      { label: "Rivalry identity", value: "England vs Australia" },
      { label: "Popular query", value: "What is the Ashes?" },
    ],
    famousMatches: ["ashes-2005-edgbaston", "ashes-2019-headingley", "ashes-2023-headingley-test"],
    relatedPlayers: ["joe-root", "steve-smith", "ben-stokes", "ricky-ponting"],
    relatedRecords: ["highest-run-chase-test", "most-runs-test"],
  },
]

function withEnglishTournamentCopy(tournament: CricketTournamentPage): CricketTournamentPage {
  return {
    ...tournament,
    definition: `${tournament.title} is a ${tournament.type} cricket tournament played in the ${tournament.hero.format} format.`,
    summary: `${tournament.title} page covers winners, format, records, top performances, famous matches, and related player links in English.`,
    history: [
      `${tournament.title} has been part of cricket history since ${tournament.hero.firstPlayed}.`,
      `The tournament is tracked here through winners, famous matches, records, and major performances.`,
    ],
    formatNotes: [
      `${tournament.title} uses ${tournament.hero.format} cricket context and usually involves ${tournament.hero.teams} teams.`,
      `The page connects tournament structure with records, match pages, and player profiles.`,
    ],
    records: tournament.records.map((record) => ({
      ...record,
      note: record.note ? `${record.label} record for ${tournament.title}.` : record.note,
    })),
    topPerformances: tournament.topPerformances?.map((performance) => ({
      ...performance,
      note: `${performance.player}'s ${performance.performance} is a key performance linked to ${tournament.title}.`,
    })),
    timeline: tournament.timeline?.map((entry) => ({
      ...entry,
      event: `${tournament.title} milestone for ${entry.year}.`,
    })),
  }
}

export const cricketTournaments: CricketTournamentPage[] = baseCricketTournaments.map(withEnglishTournamentCopy)

export function getCricketTournament(slug: string) {
  return cricketTournaments.find((tournament) => tournament.slug === slug)
}




